import { ComponentRef, Injectable } from '@angular/core';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { Observable } from 'rxjs';
import { CompleteActionItemComponent } from '../components/complete-action-item/complete-action-item.component';

@Injectable({
  providedIn: 'root',
})
export class CompleteActionItemDialogService {
  constructor(private dialogService: DialogService) {}
  public open(): {
    result$: Observable<DialogCloseResult | DialogResult>;
    instance: CompleteActionItemComponent;
  } {
    const dialog: DialogRef = this.dialogService.open({
      content: CompleteActionItemComponent,
      height: '90vh',
      minWidth: '1166px',
      width: '90vw',
      cssClass: 'error-warning-dialog',
    });
    const content: ComponentRef<CompleteActionItemComponent> =
      dialog.content as ComponentRef<CompleteActionItemComponent>;
    const instance: CompleteActionItemComponent = content.instance;
    return {
      result$: dialog.result as Observable<DialogCloseResult | DialogResult>,
      instance,
    };
  }
}
